module.exports = __webpack_public_path__ + "static/media/artillery_strip_120.23ea25e5.png";